module.exports = __webpack_public_path__ + "static/img/partIcon03.8282659a.png";